"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.minutesToTimeString = exports.timeToShortString = exports.timeToString = void 0;
var humanize_duration_1 = __importDefault(require("humanize-duration"));
var SECONDS_IN_1MIN = 60;
var formatter = function (baseUnit) {
    return function (count) {
        if (count === void 0) { count = 0; }
        return count > 1 ? "".concat(baseUnit, "s") : baseUnit;
    };
};
function timeToStringFactory(factoryHumanizer) {
    return function timeToString(timeInSeconds, alwaysShowSeconds, fullInscription) {
        if (alwaysShowSeconds === void 0) { alwaysShowSeconds = false; }
        if (fullInscription === void 0) { fullInscription = false; }
        var units = ['y', 'mo', 'd', 'h', 'm'];
        // If we have less than a minute to format or we always want to show seconds
        // then include seconds as a valid unit
        if (timeInSeconds <= SECONDS_IN_1MIN || alwaysShowSeconds) {
            units.push('s');
        }
        var options = {
            units: units,
            maxDecimalPoints: 0,
            spacer: '',
            delimiter: ' ',
            round: true,
        };
        return fullInscription
            ? (0, humanize_duration_1.default)(timeInSeconds * 1000, options)
            : factoryHumanizer(timeInSeconds * 1000, options);
    };
}
function timeToString(timeInSeconds, alwaysShowSeconds, fullInscription) {
    if (alwaysShowSeconds === void 0) { alwaysShowSeconds = false; }
    if (fullInscription === void 0) { fullInscription = false; }
    var _timeToString = timeToStringFactory(humanize_duration_1.default.humanizer({
        language: 'shortEn',
        languages: {
            shortEn: {
                y: formatter('yr'),
                mo: formatter('mon'),
                w: formatter('wk'),
                d: formatter('day'),
                h: formatter('hr'),
                m: formatter('min'),
                s: formatter('sec'),
                ms: function () { return 'ms'; },
            },
        },
    }));
    return _timeToString(timeInSeconds, alwaysShowSeconds, fullInscription);
}
exports.timeToString = timeToString;
function timeToShortString(seconds, options) {
    if (options === void 0) { options = {}; }
    if (seconds === 0) {
        return '0s';
    }
    var _timeToShortString = timeToStringFactory(humanize_duration_1.default.humanizer({
        language: 'shortEn',
        languages: {
            shortEn: {
                y: function () { return 'y'; },
                mo: function () { return 'mon'; },
                w: function () { return 'wk'; },
                d: function () { return 'd'; },
                h: function () { return 'h'; },
                m: function () { return 'm'; },
                s: function () { return 's'; },
                ms: function () { return 'ms'; },
            },
        },
    }));
    var time = options.roundMinutes
        ? Math.round(seconds / SECONDS_IN_1MIN) * SECONDS_IN_1MIN
        : seconds;
    return _timeToShortString(time, options.showSecondsWithMins, false);
}
exports.timeToShortString = timeToShortString;
function minutesToTimeString(minutes) {
    return minutes <= 60
        ? "".concat(minutes, " minute").concat(minutes === 1 ? '' : 's')
        : timeToShortString(minutes * 60);
}
exports.minutesToTimeString = minutesToTimeString;
